import type IdentityInfo from './IdentityInfo';
import type IdentityKey from './IdentityKey';

/**
 * Provides a string that can be used for in-memory indexer of a IdentityInfo in a map
 * or other structure where an indexer value is needed.
 * @param identityInfo IndentityInfo for which the indexer is to be returned
 * @returns IdentityKey for the IdentityInfo
 */
export default function getIdentityKeyForIdentityInfo(identityInfo: IdentityInfo): IdentityKey {
    return `${identityInfo.providerType}:${identityInfo.userPrincipalName}` as IdentityKey;
}
